import React, { FunctionComponent, useState } from "react";
import {
  styled,
  Block,
  Input,
  Icon,
  TransitionBase,
  IInputProps,
  ReactInputProps,
  unit,
  Button,
} from "../../../seenspire-library";
import { Container, IContainer } from "../Container/Container";

export const SEARCH_DEFAULT_HEIGHT = 64;

interface ISearchProps extends IInputProps, ReactInputProps {
  darkMode?: boolean;
  onClearValue?: () => void;
}
const SearchInput = styled(Input)`
  background-color: transparent;
  padding: 20px;
  border: none;
  height: 100%;
  font-size: 18px;
  font-weight: 200;
`;

const SearchIcon = styled(Icon)`
  position: absolute;
  left: 32px;
  top: 50%;
  transform: scale(1) translateY(-50%);
  width: 24px;
  height: 24px;
`;

const ClearIcon = styled(Icon)`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: scale(1) translateY(-50%);
`;

const SearchContainer = styled(Container).attrs({})<{
  focused: boolean;
  darkMode?: boolean;
}>`
  position: relative;
  padding-left: 54px;
  height: ${unit(SEARCH_DEFAULT_HEIGHT)};
  overflow: hidden;
  z-index: ${({ theme }) => theme.header.zIndex + 1};
  background-color: ${({ theme, focused, darkMode }) => {
    if (darkMode) return "transparent;";
    // return focused ? theme.colors.gray.lightest : theme.colors.white.base;
  }};
  box-shadow: ${({ theme, shadow, focused, darkMode }) => {
    // if (shadow === undefined) return 'none';
    if (darkMode) return "none";
    // return focused ? theme.shadows.darker : theme.shadows.dark;
    return theme.shadows.dark;
  }};
  ${TransitionBase};
  ${SearchInput} {
    color: ${({ theme, darkMode }) =>
      darkMode ? theme.colors.white.base : theme.colors.primary.dark};
    background-color: ${({ darkMode }) => darkMode && "transparent"};
    ::placeholder {
      font-size: 15px;
      color: ${({ theme, darkMode }) =>
        darkMode ? theme.colors.white.base : theme.colors.gray.darkest};
      opacity: 0.5;
    }
  }
  ${SearchIcon} {
    transform: ${({ focused }) => focused && "scale(1.2) translateY(-40%)"};
    ${TransitionBase};
    svg {
      fill: ${({ theme, focused, darkMode }) => {
        if (darkMode) return theme.colors.white.base;
        return theme.colors.gray.darkest;
      }};
      ${TransitionBase};
    }
  }
`;

const Search: FunctionComponent<ISearchProps & IContainer> = ({
  onChange,
  onClearValue,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState("");
  const clear = () => {
    setValue("");
    onClearValue && onClearValue();
  };
  return (
    <SearchContainer skipContentPadding focused={focused} {...props}>
      <SearchIcon name="search" />
      <SearchInput
        value={value}
        elementHeightBase={false}
        elementWidth="block"
        fontSize="larger"
        color="gray"
        shade="lighter"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(event) => {
          setValue(event.target.value);
          onChange && onChange(event);
        }}
        {...(props as any)}
      />
      {value && onClearValue && (
        <ClearIcon
          opacity={0.3}
          iconSize="small"
          name="cross"
          onClick={clear}
        />
      )}
      {/* Filters selects */}
    </SearchContainer>
  );
};

export default Search;
